import { PropsWithChildren } from 'react'
import Heading from '../common/pure/Heading'
import { Column } from '../common/pure/FlexContainer'

export interface FlowCardStepProps extends PropsWithChildren {
    title: string
    subtitle?: string
}
export default function FlowCardStep({ title, subtitle, children }: FlowCardStepProps) {
    return (
        <Column className="flow-card-step" gap={0.5} tall arrangement="spaced">
            <Column className="flow-card-step__heading">
                <Heading size={3}>{title}</Heading>
                <Heading size={5}>{subtitle}</Heading>
            </Column>
            <Column grow className="flow-card-step__content">
                {children}
            </Column>
        </Column>
    )
}
